export default "__VITE_ASSET__DwZE8wFb__"